import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPress = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 60 22"
		{...props}
	>
		<rect
			width={60}
			height={22}
			fill="#003049"
			fillOpacity={0.13}
			rx={4}
			style={{
				fill: '#003049',
				fillOpacity: 0.13,
			}}
		/>
		<path
			fill="#003049"
			d="M6.959 15V6.273h3.11q1.02 0 1.688.37.669.372 1.002 1.015.332.639.332 1.44 0 .806-.337 1.449a2.44 2.44 0 0 1-1.005 1.014q-.67.37-1.684.37H7.926v-1.116h2.02q.643 0 1.044-.221.4-.225.588-.614.188-.387.188-.882t-.188-.878a1.35 1.35 0 0 0-.592-.6q-.401-.218-1.057-.218H8.276V15zm7.573 0V8.455h1.232v1.04h.068q.18-.53.63-.832a1.8 1.8 0 0 1 1.032-.306 5 5 0 0 1 .541.03v1.218a2 2 0 0 0-.273-.047q-.195-.03-.392-.03-.451 0-.805.192a1.43 1.43 0 0 0-.759 1.283V15zm7.192.132q-.967 0-1.666-.413a2.8 2.8 0 0 1-1.074-1.172q-.375-.759-.375-1.777 0-1.005.375-1.773.38-.766 1.057-1.197.682-.43 1.594-.43.554 0 1.074.183a2.6 2.6 0 0 1 .933.575q.414.391.652 1.018.24.623.239 1.513v.452h-5.204v-.955h3.955a1.9 1.9 0 0 0-.204-.89 1.55 1.55 0 0 0-.576-.618 1.6 1.6 0 0 0-.86-.226q-.537 0-.938.264-.396.26-.614.682a2 2 0 0 0-.213.908v.745q0 .657.23 1.117.235.46.652.703.418.239.976.239.363 0 .66-.103.3-.106.516-.315a1.4 1.4 0 0 0 .333-.516l1.206.218q-.145.533-.52.933a2.5 2.5 0 0 1-.933.618 3.5 3.5 0 0 1-1.275.217m9.127-5.08-1.155.205a1.4 1.4 0 0 0-.23-.422 1.14 1.14 0 0 0-.417-.328 1.5 1.5 0 0 0-.66-.128q-.543 0-.904.243-.363.24-.363.618 0 .329.243.528.243.2.785.329l1.04.238q.902.21 1.346.644.443.435.443 1.129 0 .588-.34 1.048-.338.456-.943.716-.6.26-1.393.26-1.1 0-1.794-.469-.695-.472-.852-1.342l1.231-.187q.115.48.473.728.358.243.933.243.627 0 1.002-.26.375-.264.375-.643a.67.67 0 0 0-.23-.516q-.225-.21-.695-.315l-1.108-.243q-.915-.21-1.355-.665-.435-.456-.435-1.155 0-.579.324-1.014a2.1 2.1 0 0 1 .895-.678q.57-.247 1.308-.247 1.062 0 1.67.46.61.457.806 1.224m6.434 0-1.155.205a1.4 1.4 0 0 0-.23-.422 1.14 1.14 0 0 0-.418-.328 1.5 1.5 0 0 0-.66-.128q-.541 0-.904.243-.362.24-.362.618 0 .329.243.528.243.2.784.329l1.04.238q.903.21 1.346.644t.444 1.129q0 .588-.341 1.048-.337.456-.942.716-.6.26-1.394.26-1.098 0-1.793-.469-.696-.472-.853-1.342l1.232-.187q.114.48.473.728.358.243.933.243.627 0 1.001-.26.375-.264.375-.643a.67.67 0 0 0-.23-.516q-.225-.21-.694-.315l-1.108-.243q-.917-.21-1.355-.665-.435-.456-.435-1.155 0-.579.324-1.014a2.1 2.1 0 0 1 .895-.678q.57-.247 1.308-.247 1.06 0 1.67.46.61.457.806 1.224"
			style={{
				fill: '#003049',
				fillOpacity: 1,
			}}
		/>
		<path
			stroke="#003049"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.167}
			d="M42.332 6.334v.816c0 1.96 0 2.94.382 3.69a3.5 3.5 0 0 0 1.53 1.529c.748.381 1.728.381 3.688.381h3.733m0 0L48.75 9.834m2.916 2.916-2.916 2.917"
			style={{
				stroke: '#003049',
				strokeOpacity: 1,
			}}
		/>
	</svg>
);
export default SvgPress;
